var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement-datail"},[_c('div',{staticClass:"agreement-datail-content",domProps:{"innerHTML":_vm._s(_vm.agreementContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }